'use strict';

const LoginRoutes = ($stateProvider, StripeCheckoutProvider) => {

  $stateProvider.state('login', {
    url: '/login?token&location',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    params: {
      location: null
    },
    templateUrl: 'login/templates/login.tpl.html'
  });

  $stateProvider.state('forgot-password', {
    url: '/forgot-password',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/forgotpassword.tpl.html'
  });

  $stateProvider.state('invite', {
    url: '/beta?invite&origin',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      invite: true,
      classes: ''
    },
    templateUrl: 'login/templates/invite.tpl.html'
  });

  $stateProvider.state('reset-password', {
    url: '/reset-password?reset&origin',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/resetpassword.tpl.html'
  });

  $stateProvider.state('set-password', {
    url: '/set-password?verify&reset',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/setpassword.tpl.html'
  });

  $stateProvider.state('signup-form', {
    url: '/signup-form?plan_id&uav&coupon&email&firstName&lastName&organization',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/signupEmbed.tpl.html',
    resolve: {
      stripe: StripeCheckoutProvider.load
    }
  });

  // Signup for free trials is discontinued, it will redirect now to the 'login' page
  $stateProvider.state('signup', {
    url: '/signup?plan_id&uav&coupon&email&firstName&lastName&organization',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/signup.tpl.html',
    resolve: {
      authenticate: [
        '$q', '$state', '$timeout', 'AuthService', 'IdentityService',
        ($q, $state, $timeout, AuthService, IdentityService) => {

          const deferred = $q.defer();
          const authenticated = AuthService.isAuthenticated();

          // $timeout is another of those ng 'hacks'...
          // http://stackoverflow.com/questions/29811045/how-to-redirect-in-a-ui-router-resolve
          $timeout(() => {

            if (authenticated) {
              const user = IdentityService.getUser();

              // If the user is logged in, redirect to viewer
              if (user && (!user.group || user.group !== 'anon')) {
                $state.go('dash.map');
                deferred.reject();
              }
              else {
                // Redirect to /login (free trials discontinued)
                $state.go('login');
                deferred.reject();
              }
            }
            else {
              // Redirect to /login (free trials discontinued)
              $state.go('login');
              deferred.reject();
            }
          });

          return deferred.promise;
        }
      ],
      stripe: StripeCheckoutProvider.load
    }
  });

  // Signup will be only accessible to admins on the 'signup/admin' route
  $stateProvider.state('adminSignup', {
    url: '/signup/admin',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/signup.tpl.html',
    resolve: {
      authenticate: [
        '$q', '$state', '$timeout', 'AuthService', 'IdentityService',
        ($q, $state, $timeout, AuthService, IdentityService) => {

          const deferred = $q.defer();
          const authenticated = AuthService.isAuthenticated();

          // $timeout is another of those ng 'hacks'...
          // http://stackoverflow.com/questions/29811045/how-to-redirect-in-a-ui-router-resolve
          $timeout(() => {

            if (authenticated) {
              const user = IdentityService.getUser();

              if (user && (!user.group || user.group !== 'anon') && user.isAdmin) {

                // If the user is logged in as admin, render signup form
                deferred.resolve();
              }
              else {
                // Redirect to /login
                $state.go('login');
                deferred.reject();
              }
            }
            else {
              // Redirect to /login
              $state.go('login');
              deferred.reject();
            }
          });

          return deferred.promise;
        }
      ],
      stripe: StripeCheckoutProvider.load
    }
  });


  $stateProvider.state('signuprc', {
    url: '/signup_rc?coupon&email&firstName&lastName&organization',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/signupRc.tpl.html',
    resolve: {
      authenticate: [
        '$q', '$state', '$timeout', 'AuthService', 'IdentityService',
        ($q, $state, $timeout, AuthService, IdentityService) => {

          const deferred = $q.defer();
          const authenticated = AuthService.isAuthenticated();

          // $timeout is another of those ng 'hacks'...
          // http://stackoverflow.com/questions/29811045/how-to-redirect-in-a-ui-router-resolve
          $timeout(() => {

            if (authenticated) {
              const user = IdentityService.getUser();

              // If the user is logged in, redirect to viewer
              if (user && (!user.group || user.group !== 'anon')) {
                $state.go('dash.map');
                deferred.reject();
              }
              else {
                // Redirect to /login (free trials discontinued)
                $state.go('login');
                deferred.reject();
              }
            }
            else {
              // Redirect to /login (free trials discontinued)
              $state.go('login');
              deferred.reject();
            }
          });

          return deferred.promise;
        }
      ],
      stripe: StripeCheckoutProvider.load
    }
  });

  $stateProvider.state('adminLogin', {
    url: '/login/admin',
    controller: 'AdminLoginFormController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/adminLogin.tpl.html'
  });

  $stateProvider.state('select-organization', {
    url: '/select-organization',
    controller: 'LoginController',
    controllerAs: 'login',
    data: {
      classes: ''
    },
    templateUrl: 'login/templates/selectorganization.tpl.html',
    resolve: {
      verifyOrgs: [
        '$state', '$timeout', 'AuthService', 'IdentityService',
        ($state, $timeout, AuthService, IdentityService) => {

          const user = IdentityService.get('user');
          const authenticated = AuthService.isAuthenticated();

          $timeout(() => {

            // if user in local storage is missing, anonymous or does not have multiple orgs, redirect to login or dashboard based on authentication
            if (!user || (user.group && user.group === 'anon') || user.organizations.length < 2) {
              if (authenticated) {
                $state.go('dash.map');
              }
              else {
                IdentityService.set('currentOrganization', {});
                $state.go('login');
              }
            }
          });
        }
      ]
    }
  });

  $stateProvider.state('logout', {
    url: '/logout',
    controller: [
      '$timeout', '$state', 'sbAuth', 'IdentityService', 'IntercomService', 'RavenService', 'SocialLoginService', 'PlanStore', 'OrganizationStore',
      ($timeout, $state, sbAuth, IdentityService, IntercomService, RavenService, SocialLoginService, PlanStore, OrganizationStore) => {

        return SocialLoginService.logout()
          .then(() => {

            sbAuth.logout();
          })
          .then(() => {

            IdentityService.$$clearCache();
            IntercomService.shutdown();
            RavenService.syncUser();
            PlanStore.clearStore();
            OrganizationStore.clearStore();

            $state.go('login');
          })
          .catch((err) => {

            console.error(err);
          });
      }
    ]
  });
};

LoginRoutes.$inject = ['$stateProvider', 'StripeCheckoutProvider'];
module.exports = LoginRoutes;



// WEBPACK FOOTER //
// ./src/app/login/LoginRoutes.js